import cast from './cast'

/**
 * 文字列操作ユーティリティ
 */
export default {
  /**
   * Emptyかどうか比較
   * NullもEmptyとして判断する
   *
   * @param value 値
   * @returns Emptyならtrue
   */
  isEmpty (value) {
    if (value === null) {
      return true
    }
    if (typeof value === 'string' && value.length === 0) {
      return true
    }

    return false
  },

  /**
   * Empty or undefinedかどうか比較
   * NullもEmptyとして判断する
   *
   * @param value 値
   * @returns Emptyならtrue
   */
  isEmptyOrUndef (value) {
    if (value === undefined) {
      return true
    }

    return this.isEmpty(value)
  },

  /**
   * 日付を表示用に整形
   * @param value 値
   */
  formatDate (value) {
    let buff = cast.datetime(value)
    if (buff === null) {
      return ''
    }

    const y = buff.getFullYear()
    const m = buff.getMonth() + 1
    const d = buff.getDate()

    return `${('0000' + y).slice(-4)}-${('00' + m).slice(-2)}-${('00' + d).slice(-2)}`
  },
  /**
   * 日時を表示用に整形
   * @param value
   */
  formatDatetime (value) {
    let buff = cast.datetime(value)
    if (buff === null) {
      return ''
    }

    const y = buff.getFullYear()
    const m = buff.getMonth() + 1
    const d = buff.getDate()
    const hh = buff.getHours()
    const mm = buff.getMinutes()

    return `${('0000' + y).slice(-4)}-${('00' + m).slice(-2)}-${('00' + d).slice(-2)} ${('00' + hh).slice(-2)}:${('00' + mm).slice(-2)}`
  },

  /**
   * カンマ区切りの文字列
   *
   * @param num 数値
   */
  commaNumber (num) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  },

  /**
   * （ゼロ）パディング
   * @param value
   * @param digit
   * @param char
   */
  padding (value, digit, char) {
    let c = char || '0'
    return (Array(digit).join(c) + value).slice(-parseInt(digit))
  },

  /**
   *（ゼロ）サプレス
   * @param {*} value
   */
  suppression (value) {

  }
}
